import React from "react";
import Icon from "@ant-design/icons";

const StopWatchSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<g clip-path="url(#clip0_3516_59259)">
			<path
				d="M27.9908 62.4C43.4252 62.4 55.9817 49.8134 55.9817 34.3421C55.9817 20.2671 45.5882 8.58092 32.0969 6.57809C32.4268 5.95336 32.6101 5.25512 32.6101 4.50177C32.6101 2.0212 30.5938 0 28.1192 0C25.6445 0 23.6282 2.0212 23.6282 4.50177C23.6282 5.23675 23.8115 5.93498 24.1231 6.54134C10.5034 8.4523 0 20.1936 0 34.3421C0 49.8134 12.5565 62.4 27.9908 62.4ZM28.1008 2.99505C28.9257 2.99505 29.6039 3.67491 29.6039 4.50177C29.6039 5.32862 28.9257 6.00848 28.1008 6.00848C27.2759 6.00848 26.5977 5.32862 26.5977 4.50177C26.5977 3.67491 27.2759 2.99505 28.1008 2.99505ZM27.9908 9.27915C41.7755 9.27915 52.9938 20.5244 52.9938 34.3421C52.9938 48.1597 41.7755 59.405 27.9908 59.405C14.2062 59.405 2.98789 48.1597 2.98789 34.3421C2.98789 20.5244 14.2062 9.27915 27.9908 9.27915Z"
				fill="#344054"
			/>
			<path
				d="M27.9907 55.1238C39.429 55.1238 48.7226 45.8079 48.7226 34.3422C48.7226 22.8764 39.4107 13.5605 27.9907 13.5605C16.5707 13.5605 7.25879 22.8764 7.25879 34.3422C7.25879 45.8079 16.5524 55.1238 27.9907 55.1238ZM46.3396 34.3422C46.3396 44.4849 38.1092 52.7351 27.9907 52.7351C17.8722 52.7351 9.64177 44.4849 9.64177 34.3422C9.64177 24.1994 17.8722 15.9492 27.9907 15.9492C38.1092 15.9492 46.3396 24.1994 46.3396 34.3422Z"
				fill="#344054"
			/>
			<path
				d="M18.8993 44.9618C19.0276 44.9618 19.1376 44.9251 19.2476 44.8516L27.0014 39.4862C27.3314 39.5413 27.6613 39.5781 28.0096 39.5781C30.8875 39.5781 33.2338 37.2261 33.2338 34.3413C33.2338 34.1759 33.2338 33.9922 33.2155 33.8268L39.7962 23.4085C39.9428 23.1696 39.9062 22.8572 39.7229 22.6735C39.5212 22.4714 39.2096 22.4346 38.9896 22.5816L28.6695 29.1413C28.4495 29.1229 28.2479 29.1046 28.0279 29.1046C25.15 29.1046 22.8037 31.4565 22.8037 34.3413C22.8037 34.9293 22.9137 35.4989 23.0787 36.0318L18.4227 44.0798C18.2761 44.3187 18.331 44.6311 18.5327 44.8148C18.6427 44.9251 18.7893 44.9802 18.936 44.9802L18.8993 44.9618ZM30.1909 29.5823L37.3582 25.0254L32.7939 32.2282C32.2806 31.0523 31.3458 30.1152 30.1909 29.5639V29.5823ZM28.0096 32.0996C29.2378 32.0996 30.2459 33.1102 30.2459 34.3413C30.2459 35.5724 29.2378 36.583 28.0096 36.583C26.7815 36.583 25.7733 35.5724 25.7733 34.3413C25.7733 33.1102 26.7815 32.0996 28.0096 32.0996ZM25.6083 39.0085L20.769 42.3526L23.6836 37.318C24.1785 38.0346 24.8201 38.6042 25.59 39.0085H25.6083Z"
				fill="#344054"
			/>
			<path
				d="M10.4668 34.3427C10.4668 34.6734 10.7418 34.949 11.0717 34.949H15.4894C15.8193 34.949 16.0943 34.6734 16.0943 34.3427C16.0943 34.0119 15.8193 33.7363 15.4894 33.7363H11.0717C10.7418 33.7363 10.4668 34.0119 10.4668 34.3427Z"
				fill="#344054"
			/>
			<path
				d="M40.7494 34.949H45.1671C45.4971 34.949 45.772 34.6734 45.772 34.3427C45.772 34.0119 45.4971 33.7363 45.1671 33.7363H40.7494C40.4195 33.7363 40.1445 34.0119 40.1445 34.3427C40.1445 34.6734 40.4195 34.949 40.7494 34.949Z"
				fill="#344054"
			/>
			<path
				d="M28.1196 22.2699C28.4495 22.2699 28.7245 21.9943 28.7245 21.6635V17.2353C28.7245 16.9045 28.4495 16.6289 28.1196 16.6289C27.7896 16.6289 27.5146 16.9045 27.5146 17.2353V21.6635C27.5146 21.9943 27.7896 22.2699 28.1196 22.2699Z"
				fill="#344054"
			/>
			<path
				d="M28.1196 46.4141C27.7896 46.4141 27.5146 46.6897 27.5146 47.0204V51.4487C27.5146 51.7794 27.7896 52.0551 28.1196 52.0551C28.4495 52.0551 28.7245 51.7794 28.7245 51.4487V47.0204C28.7245 46.6897 28.4495 46.4141 28.1196 46.4141Z"
				fill="#344054"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3516_59259">
				<rect width={width} height={height} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const StopWatchIcon = (props) => (
	<Icon component={() => <StopWatchSvg {...props} />} />
);

export default StopWatchIcon;
